<template>
    <div class="min-h-screen flex justify-center px-5 bg-black bg-opacity-90 p-10">
        <div class="max-w-lg self-baseline">
            <div v-if="!error && !onboardingInProgress" class="flex items-center text-xs px-3 md:px-14 mb-11">
                <div v-if="step === 1" class="flex w-10 h-10 rounded-full justify-center items-center bg-yellow-300">
                    <b>1</b>
                </div>
                <div v-else
                    class="flex w-10 h-10 rounded-full justify-center items-center bg-white bg-opacity-5"
                    @click="step = 1"
                >
                    <img class="w-6 h-6" :src="require('../../../images/onboarding/check-circle-solid.png')">
                </div>
                <div v-show="step === 1" class="text-xs text-white ml-3"><b>Baixe o aplicativo</b></div>
                <span style="height: 1px" class="bg-white bg-opacity-20 flex-1 mx-3" />
                <div class="flex w-10 h-10 rounded-full justify-center items-center"
                    :class="step === 2 ? 'bg-yellow-300' : 'bg-white bg-opacity-5 text-gray-300'"
                >
                    <b>2</b>
                </div>
                <div v-show="step === 2" class="text-xs text-white ml-3"><b>Iniciar Onboarding</b></div>
            </div>

            <div class="rounded-lg px-7 lg:px-8 py-8" style="background: #202020;">
                <img class="mx-auto pt-5" :src="$page.props.white_label.data.logo_black" width="200" />
                <div v-if="error" class="text-center p-5">
                    <div class="bg-white bg-opacity-5 rounded-full mx-auto mt-5 lg:mt-10 px-10 py-2 text-center max-w-sm">
                        <span class="text-white font-semibold uppercase">Me parece que o link<br>Expirou ou é inválido</span>
                    </div>
                    <img class="mx-auto mt-5" :src="require('../../../images/expired_access.png')" width="250"/>
                </div>

                <div v-else>
                    <div class="flex justify-center">
                        <div
                            class="bg-white bg-opacity-5 inline-block rounded-full mx-auto mt-5 lg:mt-10 px-5 py-3"
                            :class="step === 1 ? '' : 'md:w-3/4 w-full'"
                        >
                            <span v-if="!onboardingInProgress" class="text-white text-center text-xs md:text-base font-bold uppercase" >{{ textSteps.main }} <span
                                class="text-yellow-300">2GO BANK</span></span>
                            <span v-else class="text-white text-left text-xs md:text-base font-bold uppercase" >Olá,<br><span
                                class="text-yellow-300">{{ onboarding_data.name || "" }}</span></span>
                        </div>
                    </div>
                    <p class="mx-auto mt-5 text-sm md:text-sm lg:mt-5 text-gray-300 max-w-3xl text-justify">{{ textSteps.description }} </p>
                    <div v-if="step === 1 && !onboardingInProgress" class="mt-5">
                        <div  v-if="userPlatform !== 'Android'">
                            <a :href="getOnboardingUrl()">
                                <img class="mx-auto" :src="require('../../../images/onboarding/applestore.png')" width="170"/>
                            </a>
                        </div>
                        <div v-if="!['iOS', 'Android'].includes(userPlatform)" class="flex justify-between items-center w-full my-3">
                            <span style="height: 1px" class="bg-white bg-opacity-20 w-full" />
                            <span class="mx-6 text-gray-200">OU</span>
                            <span style="height: 1px" class="bg-white bg-opacity-20 w-full" />
                        </div>
                        <div v-if="userPlatform !== 'iOS'">
                            <a :href="getOnboardingUrl()">
                                <img class="mx-auto" :src="require('../../../images/onboarding/playstore.png')" width="175" />
                            </a>
                        </div>
                    </div>

                    <div class="my-5">
                        <div class="px-5 mt-10">
                            <button
                                class="w-full text-xs md:text-sm font-bold py-3 px-3 md:px-6 rounded-full uppercase bg-yellow-300 hover:bg-yellow-400"
                                @click="nextStep"
                                v-if="!onboardingInProgress"
                            >
                                {{ step === 1 ? 'Próxima etapa' : 'Iniciar Onboarding no Aplicativo' }}
                            </button>
                            <button
                                class="w-full text-xs md:text-sm font-bold py-3 px-3 md:px-6 rounded-full uppercase bg-yellow-300 hover:bg-yellow-400"
                                @click="goToApp"
                                v-else
                            >
                                CONTINUAR ONBOARDING
                            </button>
                        </div>
                    </div>
                    <div class="mt-4">
                        <p class="mx-auto text-sm text-gray-300 ">Caso tenha algum problema com o link de cadastro contate nosso suporte.</p>
                        <p class="mx-auto text-sm text-gray-300 font-bold">Número: (11) 97023-4560</p>
                        <p class="mx-auto text-sm text-gray-300 ">Horário de atendimento de segunda a sexta, das 9:00 às 18:00.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppLayout from "../../Layouts/AppLayout.vue";
import JetButton from "../../Jetstream/Button.vue";

export default {
    props: ["code", "error", "mobile_settings", "host", "onboarding_data"],
    components: {
        AppLayout,
        JetButton
    },
    data(){
        return {
            step: 1
        }
    },
    methods: {
        goToApp(){
            window.location.href = this.getOnboardingUrl(null)
        },
        nextStep(){
            if(this.step === 1){
                this.step = 2
                return
            }

            this.goToApp();
        },
        getOnboardingUrl(){
            return `https://ib2gopag.page.link/?link=https://${this.host}/onboarding?id=${this.code}${this.hasParam}`;
        },
    },
    computed:{
        textSteps(){
            return {
                main: this.step === 1 ? 'Baixe o aplicativo' : 'Realize o onboarding no aplicativo',
                description: this.onboardingInProgress
                    ? "Identificamos que você possui um processo de onboarding em andamento, para continuar, clique no botão a seguir."
                    : this.step === 1
                        ? 'Vamos começar, primeiro é necessário que você acesse essa página a partir de um dispositivo móvel IOS ou Android e baixe o aplicativo 2GO Bank clicando no botão que corresponde a loja de aplicativos do seu celular.'
                        : 'Com o aplicativo instalado, acesse o link abaixo e realize o Onboarding.'
            }
        },
        hasParam(){
            let param = "";
            if (window.location.search.includes("simple")) {
                param = "&simple=true";
            } else if (window.location.search.includes("pre-register")) {
                param = "&pre-register=true"
            } else {
                param = "&onboarding_type=complete";
            }

            param = param + `&apn=${this.mobileAppData.google_app_id}&isi=${this.mobileAppData.apple_app_id}`
            return param;
        },
        onboardingInProgress(){
            return this.onboarding_data?.federal_document !== null;
        },
        userPlatform(){
            return this.mobile_settings?.platform || "Unknown";
        },
        mobileAppData(){
            return this.mobile_settings?.mobile_ib || {
                name: "2GO Bank",
                google_app_id: "com.ib2gopag.app",
                google_store_url: "https://play.google.com/store/apps/details?id=com.ib2gopag.app",
                apple_store_url: "https://apps.apple.com/tm/app/2go-bank/id1603338816",
            }
        }
    }
};
</script>

